import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { GridComponent } from './view/grid.component';
import 'ag-grid-enterprise';
import { ContactCellRendererComponent } from './cell-renderers/contact-cell-renderer.component';
import { CheckBoxRendererComponent } from './cell-renderers/checkbox-cell-renderer.component';
import { LogoCellRendererComponent } from './cell-renderers/logo-cell-renderer.component';
import { ProgressCommentCellRendererComponent } from './cell-renderers/progress-comment-cell-renderer.component';
import { CompanyCellRendererComponent } from './cell-renderers/company-cell-renderer.component';
import { ProjectCellRendererComponent } from './cell-renderers/project-cell-renderer.component';
import { RouterModule } from '@angular/router';
import { ButtonCellRendererComponent } from './cell-renderers/button-cell-renderer.component';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AgGridModule.withComponents([]),
    SweetAlert2Module
  ],
  declarations: [
    GridComponent,
    ContactCellRendererComponent,
    CheckBoxRendererComponent,
    LogoCellRendererComponent,
    ProgressCommentCellRendererComponent,
    CompanyCellRendererComponent,
    ProjectCellRendererComponent,
    ButtonCellRendererComponent
  ],
  exports: [
    GridComponent,
    ContactCellRendererComponent,
    CheckBoxRendererComponent,
    LogoCellRendererComponent,
    ProgressCommentCellRendererComponent,
    CompanyCellRendererComponent,
    ProjectCellRendererComponent,
    ButtonCellRendererComponent
  ]
})
export class GridModule { }



// WEBPACK FOOTER //
// ./client/app/shared/grid/grid.module.ts